// extracted by mini-css-extract-plugin
export default {"mainContainer":"mainContainer___AGbOw","locationsNumberContainer":"locationsNumberContainer___bP2A4"};